import SelectMUI from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import { ListItemIcon, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import "./Select.css";

const Select = (props) => {
    const {
        name, label, subtitle, control, error,
        placeholder, disabled, options,
        value, onChange,
        className,
    } = props;

    if (!control) {
        return (
            <FormControl error={!!error} className={`select-field${disabled ? " field-disabled" : ""} ${className}`}>
                {label && <label htmlFor={name}>{label}</label>}
                {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
                <SelectMUI
                    id={name}
                    variant="outlined"
                    disabled={disabled}
                    value={value}
                    displayEmpty
                    onChange={(e) => onChange?.(e.target.value)}
                >
                    {placeholder && (
                        <MenuItem disabled value="" className="select-field__item-placeholder">
                            <em>{placeholder}</em>
                        </MenuItem>
                    )}
                    {options.map((option) => (
                        <MenuItem
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                            className={`select-field__item${option.groupType ? " select-field__item--group" : ""}`}
                        >
                            {option.label}
                            {option.icon && <ListItemIcon className="select-field__item-icon">{option.icon}</ListItemIcon>}
                        </MenuItem>
                    ))}
                </SelectMUI>
                {error ? <FormHelperText>{error}</FormHelperText> : null}
            </FormControl>
        );
    }

    return (
        <FormControl error={!!error} className={`select-field${disabled ? " field-disabled" : ""} ${className}`}>
            {label && <label htmlFor={name}>{label}</label>}
            {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
            <Controller
                render={({ field }) => (
                    <SelectMUI
                        id={name}
                        variant="outlined"
                        disabled={disabled}
                        displayEmpty
                        {...field}
                    >
                        {placeholder && (
                            <MenuItem disabled value="" className="select-field__item-placeholder">
                                <em>{placeholder}</em>
                            </MenuItem>
                        )}
                        {options.map((option) => (
                            <MenuItem
                                key={option.value}
                                value={option.value}
                                disabled={option.disabled}
                                className={`select-field__item${option.groupType ? " select-field__item--group" : ""}`}
                            >
                                {option.label}
                                {option.icon && <ListItemIcon className="select-field__item-icon">{option.icon}</ListItemIcon>}
                            </MenuItem>
                        ))}
                    </SelectMUI>
                )}
                name={name}
                control={control}
            />
            {error ? <FormHelperText>{error}</FormHelperText> : null}
        </FormControl>
    );
};

export default Select;
